import { render, staticRenderFns } from "./NoneLayout.vue?vue&type=template&id=26b84b2e"
import script from "./NoneLayout.vue?vue&type=script&lang=js"
export * from "./NoneLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports